import { ref, onMounted, onUnmounted } from "vue";
// import $ from "jquery";

/* 전역 객체 생성 */
// popup
// const popupManager = new PopupManager();
// window.popupManager = popupManager;
// alert
// const alertManager = new AlertManager();
// window.alertManager = alertManager;

export function useCommon() {
  const width = ref(window.innerWidth);
  const height = ref(window.innerHeight);

  // 이벤트 리스너 저장을 위한 객체
  const gnbEventListeners = {
    anchors: [],
    bgMenu: null,
    gnb: null,
  };

  // 화면 해상도 체크
  const checkDeviceType = () => {
    if (width.value <= 768) {
      return "mobile"; // 768 이하를 모바일로 간주
    } else if (width.value > 768 && width.value <= 1024) {
      return "tablet"; // 768 ~ 1024px을 태블릿으로 간주
    } else {
      return "pc"; // 그 이상을 PC로 간주
    }
  };

  const handler = () => {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
    window.deviceType = checkDeviceType();

    // GNB
    gnbUi();
  };

  // 팝업 열기 메서드
  const open = (selector) => {
    const popup = document.querySelector(selector);
    if (popup) {
      popup.classList.remove("hidden");
      document.documentElement.classList.add("popup-open");
    }
  };

  // 팝업 닫기 메서드
  const close = (selector) => {
    const popup = document.querySelector(selector);
    if (popup) {
      popup.classList.add("hidden");
      document.documentElement.classList.remove("popup-open");
    }
  };

  // GNB 이벤트 리스너 제거 함수
  const removeGnbEventListeners = () => {
    const bgMenu = document.querySelector(".bg-menu");
    const gnbEl = document.querySelector(".gnb");

    // 저장된 anchor 이벤트 리스너 제거
    gnbEventListeners.anchors.forEach(({ element, listener }) => {
      element.removeEventListener("mouseover", listener);
    });
    gnbEventListeners.anchors = [];

    // bgMenu 이벤트 리스너 제거
    if (bgMenu && gnbEventListeners.bgMenu) {
      bgMenu.removeEventListener(
        "mouseleave",
        gnbEventListeners.bgMenu.mouseleave
      );
      bgMenu.removeEventListener(
        "mouseenter",
        gnbEventListeners.bgMenu.mouseenter
      );
    }

    // gnb 이벤트 리스너 제거
    if (gnbEl && gnbEventListeners.gnb) {
      gnbEl.removeEventListener("mouseleave", gnbEventListeners.gnb.mouseleave);
    }

    // 열려있는 메뉴 닫기
    if (bgMenu) bgMenu.classList.add("hidden");
    if (gnbEl) gnbEl.classList.remove("is-open");
  };

  function gnbUi() {
    const gnbEl = document.querySelector(".gnb");
    if (!gnbEl) return;

    // 이전 이벤트 리스너들 모두 제거
    removeGnbEventListeners();

    if (window.deviceType === "pc") {
      const gnbAnchors = gnbEl.querySelectorAll(".anchor");
      const bgMenu = document.querySelector(".bg-menu");
      if (!bgMenu) return;

      let timeoutId;

      // anchor 이벤트 리스너
      gnbAnchors.forEach((anchor) => {
        const mouseoverListener = () => {
          clearTimeout(timeoutId);
          bgMenu.classList.remove("hidden");
          gnbEl.classList.add("is-open");
        };

        anchor.addEventListener("mouseover", mouseoverListener);
        gnbEventListeners.anchors.push({
          element: anchor,
          listener: mouseoverListener,
        });
      });

      // bgMenu 이벤트 리스너
      const bgMenuMouseleave = () => {
        timeoutId = setTimeout(() => {
          bgMenu.classList.add("hidden");
          gnbEl.classList.remove("is-open");
        }, 100);
      };

      const bgMenuMouseenter = () => {
        clearTimeout(timeoutId);
      };

      bgMenu.addEventListener("mouseleave", bgMenuMouseleave);
      bgMenu.addEventListener("mouseenter", bgMenuMouseenter);

      gnbEventListeners.bgMenu = {
        mouseleave: bgMenuMouseleave,
        mouseenter: bgMenuMouseenter,
      };

      // gnb 이벤트 리스너
      const gnbMouseleave = () => {
        timeoutId = setTimeout(() => {
          bgMenu.classList.add("hidden");
          gnbEl.classList.remove("is-open");
        }, 100);
      };

      gnbEl.addEventListener("mouseleave", gnbMouseleave);
      gnbEventListeners.gnb = {
        mouseleave: gnbMouseleave,
      };
    }
  }

  onMounted(() => {
    handler();
    window.addEventListener("resize", handler);
    document.addEventListener("click", (event) => {
      const openTrigger = event.target.closest("[data-popup-open]");
      const closeTrigger = event.target.closest("[data-popup-close]");

      // 팝업 열기 트리거
      if (openTrigger) {
        const targetSelector = openTrigger.getAttribute("data-popup-open");
        open(targetSelector);
      }

      // 팝업 닫기 트리거
      if (closeTrigger) {
        const popup = closeTrigger.closest("[data-popup]");
        if (popup) close(`#${popup.id}`);
      }
    });
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handler);
    removeGnbEventListeners();
  });

  return { width, height };
}

// 2024-12-30 수정
// D: popover 가이드
export function popoverTrigger() {
  const popoverTriggers = document.querySelectorAll("[data-popover-trigger]");
  let activePopover = null;
  let activeTrigger = null;
  let hideTimeout = null;
  let scrollTimeout = null;

  // 스크롤 이벤트 핸들러
  window.addEventListener("scroll", () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(() => {
      if (activePopover) {
        hidePopover(activePopover);
      }
    }, 150);
  });

  popoverTriggers.forEach((trigger) => {
    const popoverId = trigger.dataset.popoverTrigger;
    const popover = document.querySelector(`[data-popover="${popoverId}"]`);

    if (popover) {
      // 잠시 보이게 만들어서 정확한 크기 계산
      popover.style.visibility = "hidden";
      popover.style.display = "block";
      popover.style.position = "fixed";
      popover.style.top = "-9999px";

      // 강제로 리플로우 발생시켜 크기 계산
      popover.offsetHeight;

      // 다시 원래 상태로
      popover.style.display = "";
      popover.style.visibility = "";
      popover.style.top = "";
    }
  });

  // 팝오버 표시 함수
  function showPopover(trigger, popover) {
    if (activePopover && activePopover !== popover) {
      hidePopover(activePopover);
    }

    // 정확한 크기 계산을 위해 잠시 보이게 설정
    popover.style.visibility = "hidden";
    popover.style.display = "block";

    const triggerRect = trigger.getBoundingClientRect();
    const popoverHeight = popover.offsetHeight;

    const popoverTop = triggerRect.top - popoverHeight - 20;
    const popoverLeft =
      triggerRect.left + triggerRect.width / 2 - popover.offsetWidth / 2;

    // 스타일 설정
    popover.style.position = "fixed";
    popover.style.top = `${popoverTop}px`;
    popover.style.left = `${popoverLeft}px`;
    popover.style.display = "";
    popover.style.visibility = "";

    activePopover = popover;
    activeTrigger = trigger;

    requestAnimationFrame(() => {
      popover.classList.add("is-active");
    });
  }

  // 팝오버 숨김 함수
  function hidePopover(popover) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }

    popover.classList.remove("is-active");
    activePopover = null;
    activeTrigger = null;
  }

  popoverTriggers.forEach((trigger) => {
    const popoverId = trigger.dataset.popoverTrigger;
    const popover = document.querySelector(`[data-popover="${popoverId}"]`);

    if (window.deviceType === "pc" || window.deviceType === "tablet") {
      // 트리거 이벤트
      trigger.addEventListener("mouseenter", function () {
        clearTimeout(hideTimeout);
        showPopover(this, popover);
      });

      trigger.addEventListener("mouseleave", (e) => {
        const toElement = e.relatedTarget;

        // 마우스가 팝오버로 이동하는 경우 무시
        if (toElement === popover || popover.contains(toElement)) {
          return;
        }

        hideTimeout = setTimeout(() => {
          hidePopover(popover);
        }, 200);
      });

      // 팝오버 이벤트
      popover.addEventListener("mouseenter", () => {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
        }
      });

      popover.addEventListener("mouseleave", (e) => {
        const toElement = e.relatedTarget;

        // 마우스가 트리거로 이동하는 경우 무시
        if (
          toElement === activeTrigger ||
          (activeTrigger && activeTrigger.contains(toElement))
        ) {
          return;
        }

        hideTimeout = setTimeout(() => {
          hidePopover(popover);
        }, 200);
      });
    } else {
      trigger.addEventListener("click", function () {
        // 이전 타임아웃 클리어
        if (hideTimeout) {
          clearTimeout(hideTimeout);
        }

        // 이미 다른 팝오버가 열려있다면 닫기
        if (activePopover && activePopover !== popover) {
          activePopover.classList.remove("is-active");
        }

        // 위치 계산
        const triggerRect = this.getBoundingClientRect();

        const popoverTop = triggerRect.top - popover.offsetHeight - 10;
        const popoverLeft =
          triggerRect.left + triggerRect.width / 2 - popover.offsetWidth / 2;

        popover.style.position = "fixed";
        popover.style.top = `${popoverTop}px`;
        popover.style.left = `${popoverLeft}px`;

        setTimeout(() => {
          popover.classList.add("is-active");
          activePopover = popover;
        }, 100);
      });
      document.addEventListener("click", () => {
        if (popover.classList.contains("is-active")) {
          popover.classList.remove("is-active");
        }
      });
    }
  });
}
